import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";
import axios from "react-axios";
import { getUserPlaylists } from "~/api/getCustomPlaylists";

const RecentUserPlaylists = ({ dir, limit = 10 }) => {
  const [loading, setLoading] = useState(true);
  const [playlists, setPlaylists] = useState([]);
  const load = async () => {
    const resp = await getUserPlaylists(axios, dir, limit);
    console.log("🚀 ~ file: RecentUserPlaylists.js:14 ~ load ~ resp:", resp);
    setPlaylists(resp.data.playlists);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);

  return (
    (playlists.length !== 0 && (
      <div className="profile-right-nav playlistCardProfile">
        <h3>
          <FontAwesomeIcon icon={faMusic} style={{ fontSize: 24, marginRight: 8 }} />
          Recent Playlists
        </h3>
        <div className="playlistSection">
          {playlists.map((p) => (
            <Link to={`/playlist/${p.id}`}>
              <Card body className={`relatedCard text-left${Number(p.collaborative) === 1 ? " is-collaborative" : ""}`}>
                <span className="title">
                  {p.name}
                  {Number(p.collaborative) === 1 && <span className="playlistCollabBadge">Collaborative</span>}
                </span>
                <span className="author">Created: {new Date(p.datetime).toLocaleDateString()}</span>
              </Card>
            </Link>
          ))}
        </div>
        <div className="playlistViewAll">
          <Link to={`/playlists/user/${dir}`}>View all playlists</Link>
        </div>
      </div>
    )) ||
    null
  );
};

export default RecentUserPlaylists;
